import React from 'react'
import { HelpModal } from '../../help/help-modal.component'

export const PellLifetimeEligibilityHelp = ({modalRef}) =>
  <HelpModal innerRef={modalRef} title='How Pell Lifetime Eligibility works'>
    Pell recipients are eligible for Pell for 6 years (100% = 1 year). This tells you how much you've used so far.
    <br/><br/>
    On the MyStudentData document you downloaded, find it under "Student Pell Lifetime Eligibility Used
  </HelpModal>